// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__dpH40","spinner":"Loader_spinner__WUcHX","spin":"Loader_spin__FCoef","loadingText":"Loader_loadingText__Qr-KC"};